import { Outlet, createFileRoute } from '@tanstack/react-router'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/contatos/$id
// Este arquivo serve como layout para rotas filhas dentro de $id (ex: /editar)
// Renderiza o Outlet para rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/contatos/$id',
)({
  component: function ContatoDetailLayout() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.CONTATOS} dashboardId={dashboardId}>
        <Outlet />
      </RequireModule>
    )
  },
})
